export default __webpack_public_path__ + "static/media/q24_step2.d4461e84.png";